module.exports = __webpack_public_path__ + "static/media/LogoTrans.3125cd81.png";